var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.61816 0C5.37109 0 5.15625 0.0966797 4.97363 0.279297L0.24707 4.79102C0.107422 4.94141 0 5.13477 0 5.4248C0 5.92969 0.386719 6.31641 0.891602 6.31641C1.0957 6.31641 1.32129 6.2627 1.52539 6.05859L5.61816 2.05176L9.7002 6.05859C9.9043 6.25195 10.1406 6.31641 10.3447 6.31641C10.8496 6.31641 11.2256 5.92969 11.2256 5.4248C11.2256 5.13477 11.1289 4.94141 10.9785 4.79102L6.2627 0.279297C6.06934 0.0966797 5.85449 0 5.61816 0ZM5.61816 16.3711C5.85449 16.3711 6.06934 16.2744 6.2627 16.0918L10.9785 11.5801C11.1289 11.4297 11.2256 11.2363 11.2256 10.9463C11.2256 10.4414 10.8496 10.0547 10.3447 10.0547C10.1406 10.0547 9.9043 10.1191 9.7002 10.3125L5.61816 14.3193L1.52539 10.3125C1.32129 10.1084 1.0957 10.0547 0.891602 10.0547C0.386719 10.0547 0 10.4414 0 10.9463C0 11.2363 0.107422 11.4297 0.24707 11.5801L4.97363 16.0918C5.15625 16.2744 5.37109 16.3711 5.61816 16.3711Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list_icon.8aa6e5dba04716bb3801faacca67a942.svg";
export { ForwardRef as ReactComponent };